module.exports = __webpack_public_path__ + "img/2_115.4c8eefa0.png";